import {
  listEventAdminAssignments,
  listEventAssignmentAdminCandidates,
  replaceEventAdminAssignments,
  selfAssignEvents,
} from '../api/taskEvents';

export const getEventUuid = (event) =>
  event?.event_uuid || event?.eventUuid || event?.uuid || event?.id || null;

export const getAdminId = (auth) =>
  auth?.userId ||
  auth?.user?.userId ||
  auth?.user?.admin_user_id ||
  auth?.user?.id ||
  auth?.adminUser?.id ||
  auth?.admin?.id ||
  auth?.data?.userId ||
  auth?.data?.id ||
  null;

export const isAdminAssignedToEvent = (event, adminId) => {
  if (!event || !adminId) return false;
  const assignees = Array.isArray(event?.assigned_admins)
    ? event.assigned_admins
    : Array.isArray(event?.assignedAdmins)
      ? event.assignedAdmins
      : [];
  return assignees.some((assignee) => {
    const id =
      assignee?.admin_user_id ??
      assignee?.adminUserId ??
      assignee?.id ??
      assignee?.user_id ??
      null;
    return id != null && Number(id) === Number(adminId);
  });
};

export const assignCurrentAdminToEvents = async (eventUuids) => {
  const ids = [...new Set(
    (Array.isArray(eventUuids) ? eventUuids : [eventUuids])
      .map((value) => String(value || '').trim())
      .filter(Boolean)
  )];
  if (!ids.length) return { assignedEventUuids: [], assignmentsByEventUuid: {} };
  return selfAssignEvents({ eventUuids: ids });
};

export const fetchEventAssignments = async (eventUuid) => {
  return listEventAdminAssignments(eventUuid);
};

export const fetchEventAssignmentAdminCandidates = async () => {
  return listEventAssignmentAdminCandidates();
};

export const updateEventAssignments = async (eventUuid, adminUserIds) => {
  return replaceEventAdminAssignments(eventUuid, { adminUserIds });
};
